import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface NewGuidService {
  getNewGuid(entityType: string): angular.IPromise<string>;
  getNewGuids(entityType: string, count: number): angular.IPromise<string[]>;
}

export default angular
  .module('aps.services.newguid', [HttpServiceName])
  .service('newGuidService', function(httpService: HttpService): NewGuidService {

    let getNewGuid = (entityType: string) => httpService
      .get<string>(Endpoints.NEWGUID, {entityType: entityType});

    let getNewGuids = (entityType: string, count: number) => httpService
      .get<string[]>(Endpoints.NEWGUID, {entityType: entityType, count: count});

    return {
      getNewGuid: getNewGuid,
      getNewGuids: getNewGuids
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/utility/newguid.service.ts